export enum RulesEngineRuleTypeEnum {
    ElynxDiagnostic = 0,
    ElynxDataQuality = 1,
    CustomDiagnostic = 2,
    CustomDataQuality = 3
}